module.exports = __webpack_public_path__ + "static/the-making-of-the-president-1960-40499fa21e3cefcb294eb8c3a2607711.jpg";